import { SearchFragmentUsers } from "@radarly/models/search";
import { useWidgetFragmentData } from "./useWidgetFragmentData";
export function useAuthorWidgetData(
  project: number,
  fragment: SearchFragmentUsers,
  mutualized: boolean = true
) {
  const { data, loading } = useWidgetFragmentData(
    project,
    fragment,
    mutualized
  );
  return {
    data,
    loading,
    isEmpty: !data || !data.total,
  };
}
